import { CacheLocation } from '@auth0/auth0-spa-js';

import * as authConfig from '../auth/auth-config.preview';

const { domain, clientId, audience } = authConfig.default;

export const portalEnvironment = {
  production: false,
  apiUrl: 'https://preview.rizeapi.azzly.com/v2/portal/v2',
  environmentName: 'preview',
  telehealthBaseUrl: 'https://preview.rize.azzly.com',
  auth: {
    domain,
    clientId,
    authorizationParams: {
      audience,
      redirect_uri: window.location.origin,
    },
    cacheLocation: 'localstorage' as CacheLocation,
    useRefreshTokens: true,
  },
  formioApiUrl: 'https://preview.formsapi.azzly.com/preview-forms',
} as const;
